import { ThemeUICSSObject, spacing } from '@apia/theme';
/* IMPORT HERE */

const files: ThemeUICSSObject = {
  display: 'flex',
  flexDirection: 'column',
  gap: spacing(4),
  maxWidth: 'min(90vw, 450px)',
  minWidth: 'min(90vw, 450px)',
  /* PREPEND HERE */
};

export default files;
